import { render, staticRenderFns } from "./ListadoPartida.vue?vue&type=template&id=8c057a6e"
import script from "./ListadoPartida.vue?vue&type=script&lang=js"
export * from "./ListadoPartida.vue?vue&type=script&lang=js"
import style0 from "./ListadoPartida.vue?vue&type=style&index=0&id=8c057a6e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports